import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight, ExternalLink } from "lucide-react";

export default function AssessmentCTA() {
  const navigate = useNavigate();
  return (
    <section id="assessment" className="relative py-16 md:py-20 bg-[#eaf3ff] overflow-hidden">
      <div className="absolute -top-16 -right-10 w-72 h-72 rounded-full bg-[#2b8cf0]/10 blur-3xl" />
      <div className="relative max-w-[1240px] mx-auto px-5">
        <div className="rounded-3xl bg-white cc-shadow-card p-8 md:p-12 grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#F58220]/10 text-[#F58220] text-xs font-semibold font-head">
              <Sparkles size={14} /> DISCOVER YOUR STRENGTHS
            </span>
            <h2 className="font-head text-2xl md:text-3xl font-bold text-[#16244F] mt-4 leading-snug">
              Take our quick career-interest quiz &mdash; or the full BrightIQ assessment
            </h2>
            <p className="text-[#5a6274] mt-4 max-w-xl">
              Start with a free 2-minute quiz that suggests career streams matching your interests. Ready for deeper insight?
              Our psychometric assessment is powered by <strong className="text-[#16244F]">BrightIQ</strong> &mdash; mapping aptitude,
              personality, interest, intelligence and values into one counselor-reviewed report.
            </p>
            <div className="mt-7 flex flex-wrap gap-4">
              <button
                onClick={() => navigate("/assessment")}
                className="group inline-flex items-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold px-6 py-3.5 rounded-lg transition-colors"
              >
                Take the Free Quiz <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </button>
              <a
                href="https://brightiq.in"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border-2 border-[#16244F] text-[#16244F] hover:bg-[#16244F] hover:text-white font-head font-semibold px-6 py-3 rounded-lg transition-colors"
              >
                Full Assessment on BrightIQ <ExternalLink size={16} />
              </a>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4">
            {[
              { n: "5", l: "sciences mapped" },
              { n: "40+", l: "career clusters" },
              { n: "15m", l: "to first insight" },
            ].map((s) => (
              <div key={s.l} className="text-center rounded-2xl bg-[#f6f8fc] py-6 px-2">
                <div className="font-head text-3xl font-extrabold text-[#2b8cf0]">{s.n}</div>
                <div className="text-xs text-[#5a6274] mt-1 leading-tight">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
